export default __webpack_public_path__ + "static/media/wuyeSeven.a056cd4e.png";